<template>
  <div class="custom-bundle-shell d-flex flex-column flex-column-fluid">
    <div class="hero-banner">
      <div class="app-container container-fluid">
        <div class="hero-content">
          <div>
            <p class="eyebrow">باقة مخصصة لأجمل تجربة تعليمية</p>
            <h1>قائمة بكل الدورات الموجودة</h1>
            <p class="subtitle">
              اختر أفضل الدورات، أعد ترتيب باقتك الخاصة، واطّلع على تفاصيل الطلب في لحظات.
            </p>
          </div>
          <div class="hero-stats" v-if="!isloading && courses.length">
            <div class="stat-card">
              <span>عدد الدورات</span>
              <strong>{{ courses.length }}</strong>
            </div>
            <div class="stat-card">
              <span>إجمالي السعر</span>
              <strong>{{ totalPrice }} د.ل</strong>
            </div>
            <div class="stat-card">
              <span>التخفيض الحالي</span>
              <strong>{{ discountPercentage }}%</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isloading" class="loader-card text-center text-success">
          <div class="loader-icon">
            <span class="pulse-circle"></span>
          </div>
          <p class="mb-3">جاري تحميل الدورات المختارة...</p>
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <div
          v-if="!isloading"
          class="row g-4 g-xl-5 mb-5 mb-xl-10 courses-showcase"
        >
          <div class="col-md-6 col-xl-4" v-for="course in courses" :key="course.id">
            <div class="course-card h-100">
              <button class="remove-course" @click="removeCourse(course.id)">
                <i class="fa fa-trash text-white"></i>
              </button>
              <div class="course-thumbnail">
                <img
                  :src="course.preview_image ? `${course.preview_image}` : defaultImage"
                  :alt="'Course Thumbnail'"
                  @error="handleImageError"
                />
              </div>
              <div class="course-body">
                <small class="instructor">
                  {{ course.user.fname }} {{ course.user.lname }}
                </small>
                <h5 class="title">{{ course.title }}</h5>
                <div class="card-meta">
                  <div>
                    <span>السعر</span>
                    <strong>{{ course.price }} دينار</strong>
                  </div>
                  <div class="badge bg-light-success text-success">
                    متاح في الباقة
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isloading && courses.length != 0" class="order-summary-section">
          <div class="order-summary-wrapper">
            <div class="order-summary card shadow-lg border-0">
              <div class="card-body p-4 p-lg-5">
                <div class="order-header">
                  <div>
                    <p class="eyebrow">معاينة نهائية</p>
                    <h4 class="mb-0">تفاصيل الطلب</h4>
                  </div>
                  <span class="order-badge">
                    <i class="fa fa-receipt"></i>
                  </span>
                </div>

                <ul class="list-group list-group-flush mt-4">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span><i class="fa fa-coins text-success"></i> إجمالي السعر:</span>
                    <strong>{{ totalPrice }} دينار</strong>
                  </li>

                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span
                      ><i class="fa fa-user text-success"></i> تمت المشاركة من قبل:</span
                    >
                    <strong>{{ user.fname }} {{ user.lname }}</strong>
                  </li>

                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span><i class="fa fa-percentage text-success"></i> نسبة التخفيض:</span>
                    <strong>{{ discountPercentage }}%</strong>
                  </li>

                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span
                      ><i class="fa fa-money-bill-wave text-success"></i> السعر النهائي :</span
                    >
                    <strong>{{ discountedPrice.toFixed(2) }} دينار</strong>
                  </li>
                </ul>
                <div class="text-center mt-4">
                  <button class="btn btn-success btn-lg confirm-btn" @click="openLoginModal">
                    <i class="fa fa-check-circle"></i> تأكيد الاشتراك
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <!-- Enroll Form -->
    <form id="enroll-form" @submit.prevent="handleEnroll">
      <input type="hidden" name="subcategory_id" :value="this.subcategoryId" />
      <div v-for="course in courses" :key="course.id">
        <input
          type="hidden"
          :class="'course-' + course.id"
          :data-price="course.price"
          :data-discount="calculatedDiscount"
          name="courses_ids[]"
          :value="course.id"
        />
      </div>
      <input type="hidden" name="shared_by" id="shared_by" :value="sharedBy" />
    </form>

    <!-- Login Modal -->
    <div
      class="modal fade"
      id="loginModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="contact__left">
              <div class="section__heading mb-50 text-center">
                <img
                  src="/assets/img/logo-dark.png"
                  alt="logo-img"
                  style="width: 300px; margin: 0 auto"
                />
                <h3 class="section__heading--title mb-10">تسجيل الدخول</h3>
                <p class="section__heading--desc">
                  الرجاء إدخال بيانات حسابك في منصة أكاديميا أدناه<br />
                  ليتم إستكمال عملية الشراء
                </p>
              </div>
              <form class="contact__form" id="login-form" @submit.prevent="handleLogin">
                <div class="row">
                  <div id="validation-errors">{{ validationErrors }}</div>
                  <div class="col-lg-12 col-md-12 col-sm-12 mb-30">
                    <label for="mobile">رقم الهاتف</label>
                    <input
                      type="tel"
                      v-model="mobile"
                      class="form-control required"
                      id="mobile"
                      maxlength="10"
                    />
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                    <label for="password">كلمة المرور</label>
                    <input
                      type="password"
                      class="form-control required"
                      v-model="password"
                    />
                  </div>
                </div>
                <button
                  style="width: 100%; background-color: #00c444"
                  class="btn btn-success submit-button"
                >
                  تسجيل الدخول <i class="bi bi-arrow-left-circle-fill"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import "@/assets/blockui";
import Swal from "sweetalert2";
var iti;
var phone;
export default {
  name: "CustomBundleHome",
  data() {
    return {
      courses: [],
      isloading: true,
      totalPrice: 0,
      discountPercentage: 0,
      discountedPrice: 0,
      courseImagePath: baseUrl + "/images/course",
      defaultImage: "/assets/img/acad-icon.png",
      subcategoryId: null,
      mobile: "",
      password: "",
      user: {},
      validationErrors: "",
    };
  },

  mounted() {
    document.getElementById("currentYear").textContent = new Date().getFullYear();

    this.getShare();
    phone = document.querySelector("#mobile");
    $(document).ready(function () {
      iti = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly", // Set Libya as the default country
        separateDialCode: true,
        excludeCountries: ["il"],
      });
    });
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
    async getShare() {
      this.isloading = true;
      const urlParams = new URLSearchParams(window.location.search);
      const coursesParam = urlParams.get("courses") || "";
      const sbParam = urlParams.get("sb") || "0";
      try {
        const response = await fetch(
          `${apiUrl}/custom-bundles/share?courses=${coursesParam}&sb=${sbParam}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-country-code": "+218",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.subcategoryId = data.sub_cat.id;

          this.courses = data.courses;
          this.user = data.user;

          this.totalPrice = this.courses.reduce(
            (sum, course) => sum + Number(course.price),
            0
          );
          this.discountPercentage = Number(data.discount.discount);
          this.discountedPrice = this.totalPrice * (1 - this.discountPercentage / 100);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isloading = false;
      }
    },

    removeCourse(courseId) {
      const urlParams = new URLSearchParams(window.location.search);

      // الحصول على قيمة param sb من الـ URL
      const sbParam = urlParams.get("sb") || "0";

      // الحصول على قيم الـ "courses" من الـ URL وتحويلها إلى مصفوفة
      let coursesParam = urlParams.get("courses");
      let coursesArray = coursesParam ? coursesParam.split(",") : [];

      // التحقق إذا كان هناك كورس واحد فقط
      if (coursesArray.length <= 1) {
        Swal.fire({
          icon: "warning",
          title: "لا يمكن حذف الكورس",
          text: "يجب أن تحتوي الباقة على دورة واحدة على الأقل.",
          confirmButtonText: "حسنًا",
        });
        return;
      }

      // تأكيد الحذف باستخدام Swal.fire
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "للتأكيد اضغط نعم",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم، احذف!",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          // إزالة الكورس الذي تم حذفه من المصفوفة
          coursesArray = coursesArray.filter((course) => course !== courseId.toString());

          // تحويل المصفوفة بعد إزالة الكورس إلى سلسلة نصية جديدة
          const updatedCoursesParam = coursesArray.join(",");

          // إنشاء الـ URL الجديد بعد إزالة الكورس
          let redirectUrl = "/custome-bundle-share?sb=" + sbParam;

          if (updatedCoursesParam) {
            redirectUrl += "&courses=" + updatedCoursesParam;
          }

          // إعادة تحميل الصفحة بالـ URL الجديد
          window.location.href = redirectUrl;
        }
      });
    },
    openLoginModal() {
      const loginModal = new bootstrap.Modal(document.getElementById("loginModal"));
      loginModal.show();
    },

    async handleLogin() {
      try {
        $("#login-form").block({
          message:
            '<span style="margin:0px;padding:8px;font-size:14px;color:#29ca50;">الرجاء الإنتظار..</span>', // لون النص أخضر
          css: {
            backgroundColor: "rgba(255, 255, 255, 0.8)", // خلفية بيضاء شفافة
            color: "#000", // لون النص الافتراضي
            border: "0px",
            padding: "15px",
            "-webkit-border-radius": "10px",
            "-moz-border-radius": "10px",
            opacity: 1,
          },
          overlayCSS: {
            backgroundColor: "rgb(204 204 204 / 80%)", // تغيير لون الخلفية overlay إلى أبيض شفاف
            opacity: 0.8, // يمكنك ضبط الشفافية هنا
            cursor: "wait",
          },
        });
        const formData = new FormData();
        formData.append("mobile", iti.getNumber());
        formData.append("password", this.password);

        const response = await fetch(`${apiUrl}/loginWithoutChecks`, {
          method: "POST",

          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          this.handleEnroll(data.access_token);
        } else {
          const errorData = await response.json();
          this.validationErrors = errorData.message || "خطأ في تسجيل الدخول";
        }
      } catch (error) {
        console.error("Login error:", error);
      }
    },

    async handleEnroll(token) {
      const form = document.getElementById("enroll-form");
      const formData = new FormData(form);

      try {
        const response = await fetch(`${apiUrl}/custom-bundles/enroll`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "x-country-code": "+218",
          },
          body: formData,
        });

        if (response.ok) {
          Swal.fire({
            title: "تم الاشتراك بنجاح",
            text: "نتمنى لك التوفيق",
            icon: "success",
            confirmButtonText: "موافق",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/home"; // الانتقال إلى صفحة الرئيسية
            }
          });
        } else {
          const errorData = await response.json();
          Swal.fire({
            title: "حدثت مشكلة",
            text: errorData.message,
            icon: "error",
            confirmButtonText: "موافق",
          });
          $("#login-form").unblock();
        }
      } catch (error) {
        console.error("Enrollment error:", error);
        alert("حدث خطأ أثناء الاشتراك");
      }
    },
  },
};
</script>

<style scoped>
:global(body) {
  background: #f2f7fb;
}

.custom-bundle-shell {
  min-height: 100vh;
  background: linear-gradient(135deg, #f9fbff 0%, #eef7ff 40%, #eefdf5 100%);
}

.hero-banner {
  padding: 2rem 0 1rem;
}

.hero-content {
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 32px;
  padding: 2.5rem;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-shadow: 0 25px 50px rgba(0, 25, 70, 0.1);
}

.hero-content h1 {
  font-size: clamp(1.8rem, 3vw, 2.75rem);
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 0.5rem;
}

.hero-content .subtitle {
  color: #485470;
  font-size: 1rem;
  margin: 0;
}

.eyebrow {
  font-size: 0.85rem;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #00a86b;
  margin-bottom: 0.5rem;
}

.hero-stats {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.stat-card {
  min-width: 140px;
  flex: 1;
  background: #fff;
  color: #0f172a;
  border-radius: 18px;
  padding: 1rem 1.2rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.06);
}

.stat-card span {
  font-size: 0.85rem;
  opacity: 0.75;
}

.stat-card strong {
  font-size: 1.5rem;
  display: block;
  margin-top: 0.2rem;
}

.loader-card {
  background: #fff;
  border-radius: 28px;
  padding: 3rem 2rem;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.1);
}

.loader-icon {
  position: relative;
  width: 70px;
  height: 70px;
  margin: 0 auto 1.5rem;
}

.pulse-circle {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(0, 196, 68, 0.15);
  animation: pulse 1.5s ease infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  70% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.courses-showcase .course-card {
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #eef2ff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  position: relative;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.courses-showcase .course-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.15);
}

.remove-course {
  position: absolute;
  top: 16px;
  left: 16px;
  border: none;
  background: rgba(255, 68, 68, 0.9);
  color: #fff;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s ease;
}

.remove-course:hover {
  background: #c1121f;
}

.course-thumbnail {
  background: linear-gradient(135deg, #f4f7fb, #eef5ff);
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.course-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.course-body {
  padding: 1.5rem;
}

.course-body .instructor {
  color: #5c637b;
  display: block;
}

.course-body .title {
  font-weight: 700;
  color: #0f172a;
  margin: 0.25rem 0 1rem;
}

.card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.badge.bg-light-success {
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-size: 0.85rem;
  border: 1px solid #b3f5cf;
  background: #e8fff1;
}

.order-summary-section {
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 3rem;
  background: linear-gradient(135deg, #00c444, #00c444, #00c455);
  border-radius: 42px;
  padding: 3rem 1rem 4rem;
  position: relative;
  overflow: hidden;
}

.order-summary-section::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 10% 20%, rgba(255, 255, 255, 0.25), transparent 55%),
    radial-gradient(circle at 90% 10%, rgba(255, 255, 255, 0.2), transparent 45%),
    radial-gradient(circle at 80% 80%, rgba(0, 79, 35, 0.2), transparent 50%);
  pointer-events: none;
}

.order-summary-wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.order-summary {
  max-width: 640px;
  width: 100%;
  border-radius: 32px;
  background: #fff;
  color: #0f172a;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.18);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-header h4 {
  color: #0f172a;
}

.order-badge {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: rgba(0, 196, 68, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.order-summary .list-group-item {
  background: transparent;
  color: #0f172a;
  border-color: rgba(15, 23, 42, 0.1);
  font-size: 1rem;
}

.confirm-btn {
  width: 100%;
  background: linear-gradient(135deg, #00c444, #00a86b);
  border: none;
  padding: 0.9rem 1.5rem;
  font-size: 1.05rem;
  border-radius: 999px;
}

.confirm-btn:focus {
  box-shadow: 0 0 0 0.25rem rgba(0, 196, 68, 0.35);
}

@media (min-width: 992px) {
  .hero-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .hero-content > div:first-child {
    max-width: 55%;
  }
}

@media (max-width: 767px) {
  .hero-content {
    padding: 1.8rem;
  }

  .course-thumbnail img {
    height: 190px;
  }
}
</style>
